import { render, staticRenderFns } from "./propagandize.vue?vue&type=template&id=e9fbe5cc&scoped=true"
import script from "./propagandize.vue?vue&type=script&lang=js"
export * from "./propagandize.vue?vue&type=script&lang=js"
import style0 from "./propagandize.vue?vue&type=style&index=0&id=e9fbe5cc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9fbe5cc",
  null
  
)

export default component.exports